/**
 * Функция, которая не делает ничего
 */
export const noop = () => undefined
